import axios from 'axios';

type KafkaData = {
  userId?: string;
  action_name?: string;
  [key: string]: unknown;
};

export const sendDataToLighthouse = (data: KafkaData, userAgent?: string): void => {
  const topic = 'nama';
  if (!import.meta.env.VITE_KAFKA_PRETOPIC) {
    return;
  }

  try {
    let platform = '';
    if (userAgent !== undefined) {
      const OS = {
        isAndroid: userAgent.indexOf('android') > -1,
        isIOS: /iphone|ipad|ipod/.test(userAgent),
        isWindows: userAgent.indexOf('windows') > -1,
        isMac: userAgent.indexOf('macintosh') > -1,
        isLinux: userAgent.indexOf('linux') > -1,
        isUnix: userAgent.indexOf('x11') > -1
      };
      if (OS.isAndroid) {
        platform = 'android';
      } else if (OS.isIOS) {
        platform = 'ios';
      } else if (OS.isWindows) {
        platform = 'windows';
      } else if (OS.isMac) {
        platform = 'mac';
      } else if (OS.isLinux) {
        platform = 'linux';
      } else if (OS.isUnix) {
        platform = 'unix';
      }
    }

    const selectedVendor = JSON.parse(localStorage.getItem('selectedVendor') ?? 'null');
    const mData = {
      ...data,
      location: window.location.href,
      timeStamp: Date.now(),
      platform,
      vendor_id: selectedVendor?.id || '0',
      session_id: sessionStorage.getItem('userSessionId') || '0'
    };
    createKafkaRequest({topic, data: mData});
  } catch (error: any) {
    console.warn('kafka error ===> ', error);
  }
};

const delayBeforeRetry = 2000;
const maxDelayBeforeRetry = 4000;

const createKafkaRequest = (
  {topic, data}: {topic: string; data: KafkaData},
  retryDelay = 0
): void => {
  const body = {
    records: [
      {
        key: data.userId || localStorage.getItem('userId') || '0',
        value: data
      }
    ]
  };
  const headers = {
    headers: {
      'Content-Type': 'application/vnd.kafka.json.v2+json'
    }
  };
  setTimeout(() => {
    axios
      .post(`/kafka-events/topics/${import.meta.env.VITE_KAFKA_PRETOPIC}${topic}/`, body, headers)
      .then((res) => {
        console.log('kafka res ===> ', res);
      })
      .catch(() => {
        if (retryDelay < maxDelayBeforeRetry) {
          createKafkaRequest({topic, data}, retryDelay + delayBeforeRetry);
        }
      });
  }, retryDelay);
};
